import { sharedStaticConfig } from '@ngb-frontend/shared/config'

import type { SharedConfig } from '@ngb-frontend/shared/types'

export const getTestSharedConfig = (): SharedConfig => ({
  ...sharedStaticConfig,
  disableAuth: true,
  disableDateBlocking: true,
  mockApi: true,
  features: {
    driverCourtesy: true,
    eligibilityCheck: false,
  },
  buildInfo: {
    commitSha: '',
    branch: '',
    timestamp: '',
    productName: 'Next Generation Booking',
  },
  azure: {
    azureAD: {
      clientId: '',
      authority: 'https://login.microsoftonline.com',
    },
    azureEntraID: {
      clientId: '',
      authority: 'https://login.microsoftonline.com',
    },
    azureB2C: {
      clientId: '',
      authority: 'https://login.staging.ayvens.com',
      scope: '',
    },
  },
})
